import React, { useState, useEffect } from "react";
import {
  db,
  collection,
  deleteDoc,
  onSnapshot,
  doc,
  getDocs,
  updateDoc,
  ref,
  storage,
  uploadBytesResumable,
  getDownloadURL,
} from "../../config/firebase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Avatar, Select, Table, Button, Modal, Input } from "antd";
import Swal from "sweetalert2";
import { DialogWithImage } from "../view/view";

const { Option } = Select;

const PaymentTableData = ({ statusFilter, searchQuery }) => {
  const [data, setData] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const filteredData = data.filter((item) => {
    if (!statusFilter || item.status === statusFilter) {
      const nameMatch = item.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());
      const phoneMatch = item.phone.includes(searchQuery);

      return nameMatch || phoneMatch;
    } else {
      return false;
    }
  });

  const handleChange = async (text, id) => {
    for (const e of data) {
      if (e.id === id) {
        let text2 = text === "Verified" ? "Approved" : "pending";

        const paymentRef = doc(db, "Payment", id);
        await updateDoc(paymentRef, { status: text });

        const studentsQuery = collection(db, "Students");
        const studentQuerySnapshot = await getDocs(studentsQuery);

        studentQuerySnapshot.forEach(async (docSnapshot) => {
          console.log("E DATA", docSnapshot.data());
          if (docSnapshot.data().rollNumber === Number(e.rollnumber)) {
            const studentRef = doc(db, "Students", docSnapshot.id);
            await updateDoc(studentRef, { status: text2 });
          }
        });

        alert("Updated");
      }
    }
  };

  const handleEdit = (record) => {
    setEditingUser(record);
    setIsModalVisible(true);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this user!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    });

    if (result.isConfirmed) {
      const washingtonRef = doc(db, "Payment", id);
      await deleteDoc(washingtonRef);
      alert("Deleted");
    }
  };

  useEffect(() => {
    const q = collection(db, "Payment");
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newData = snapshot.docs.map((doc) => ({
        ...doc.data(),
        key: doc.id,
      }));
      setData(newData);
    });

    return () => unsubscribe();
  }, []);

  const handleSave = async () => {
    if (!editingUser) return;

    try {
      if (editingUser.picFile) {
        // Create a reference to the Firebase Storage location
        const storageRef = ref(storage, `payment/${editingUser.key}`);

        // Upload the file to Firebase Storage
        const uploadTask = uploadBytesResumable(
          storageRef,
          editingUser.picFile
        );
        uploadTask.on(
          "state_changed",
          (snapshot) => {},
          (error) => {
            console.error("Upload failed with error:", error);
          },
          () => {
            // When the upload is complete, get the download URL
            getDownloadURL(uploadTask.snapshot.ref)
              .then((picUrl) => {
                const washingtonRef = doc(db, "Payment", editingUser.key);

                updateDoc(washingtonRef, {
                  ...editingUser,
                  pic: picUrl,
                })
                  .then(() => {
                    setIsModalVisible(false);
                    setEditingUser(null);
                    alert("Updated");
                  })
                  .catch((error) => {
                    console.error("Error updating Firestore document:", error);
                  });
              })
              .catch((error) => {
                console.error("Error getting download URL:", error);
              });
          }
        );
      } else {
        // No new picture selected, update user document without changing the pic property
        const washingtonRef = doc(db, "Payment", editingUser.key);
        updateDoc(washingtonRef, { ...editingUser })
          .then(() => {
            setIsModalVisible(false);
            setEditingUser(null);
            alert("Updated");
          })
          .catch((error) => {
            console.error("Error updating Firestore document:", error);
          });
      }
    } catch (error) {
      console.error("Error updating profile picture:", error);
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "pic",
      render: (text) => <Avatar shape="square" src={text} size={100} />,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (pic, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ marginLeft: "0px" }}>
            <p>{record.name}</p>
            <p>
              {" "}
              <b> {record.rollnumber} </b>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Method",
      dataIndex: "method",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
        <Select
          id="admin"
          defaultValue={text}
          style={{ width: 120 }}
          onChange={(value) => handleChange(value, record.key)}
        >
          <Option value="Verified">Verified</Option>
          <Option value="Unverified">Unverified</Option>
        </Select>
      ),
    },
    {
      title: "Actions",
      render: (text, record) => (
        <div>
          <DialogWithImage data={record} />
          <Button
            onClick={() => handleEdit(record)}
            style={{ marginRight: "10px" }}
          >
            <FontAwesomeIcon
              icon={faEdit}
              style={{ color: "#ccc", marginRight: "10px" }}
            />
            Edit
          </Button>
          <Button onClick={() => handleDelete(record.key)}>
            <FontAwesomeIcon
              icon={faTrash}
              style={{ color: "#ccc", marginRight: "10px" }}
            />
            Delete
          </Button>
        </div>
      ),
    },
  ];
  console.log("filteredData", filteredData);
  return (
    <>
      <Table columns={columns} dataSource={filteredData} />
      <Modal
        title="Edit User"
        visible={isModalVisible}
        onOk={handleSave}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingUser(null);
        }}
        className="custom-modal"
        cancelButtonProps={{
          style: { backgroundColor: "white", color: "#ccc" },
        }}
        okButtonProps={{ type: "dashed" }}
      >
        {editingUser && (
          <form className="custom-form">
            {["name", "phone"].map((field) => (
              <div className="input-container" key={field}>
                <label htmlFor={field}>
                  {field === "name" ? "First Name" : field}:
                </label>
                <Input
                  id={field}
                  type={field === "dob" ? "date" : "text"}
                  placeholder={field === "name" ? "First Name" : field}
                  value={editingUser[field]}
                  onChange={(e) =>
                    setEditingUser({ ...editingUser, [field]: e.target.value })
                  }
                />
              </div>
            ))}

            <div className="input-container">
              <label htmlFor="pic">Profile Picture:</label>
              <input
                id="pic"
                type="file"
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files[0];
                  console.log(file);

                  if (file) {
                    setEditingUser({
                      ...editingUser,
                      pic: file,
                      picFile: file,
                    });
                  }
                }}
              />
            </div>
          </form>
        )}
      </Modal>
    </>
  );
};

export default PaymentTableData;
